// These definitions come from TCGPlayer: /catalog/categories/3/conditions
export const conditionIds = {
  1: {
    name: "Near Mint",
    abbreviation: "NM",
    displayOrder: 1,
  },
  2: {
    name: "Lightly Played",
    abbreviation: "LP",
    displayOrder: 2,
  },
  3: {
    name: "Moderately Played",
    abbreviation: "MP",
    displayOrder: 3,
  },
  4: {
    name: "Heavily Played",
    abbreviation: "HP",
    displayOrder: 4,
  },
  5: {
    name: "Damaged",
    abbreviation: "DM",
    displayOrder: 5,
  },
  6: {
    name: "Unopened",
    abbreviation: "U",
    displayOrder: 6,
  },
};
